import { useTranslation } from "react-i18next";
import { useState } from "react";
import { GetAllCompanyDto } from "@/types/api/api-types";
import { GeneralInfoModalCompany } from "./generalInfoModalCompany";
import { GeneralInfoModalCreateBillingEntity } from "./generalInfoModalCreateBillingEntity";
import { BillingEntityGroup } from "./billingEntityGroup";

type GeneralInfoCompanyProps = {
  company?: GetAllCompanyDto;
};

export const GeneralInfoCompany = ({ company }: GeneralInfoCompanyProps) => {
  const { t } = useTranslation(["boClients", "common"]);
  const [editing, setEditing] = useState(0);

  const handleEdit = (editIndex: number) => {
    setEditing(editIndex);
  };

  const defaultBillingEntity = company?.billingEntities.find((el) => el.isDefault);

  const otherBillingEntities = company?.billingEntities.filter((el) => el.isDefault === false);

  const displayModal = () => {
    switch (editing) {
      case 1:
        return <GeneralInfoModalCompany closeModal={() => setEditing(0)} company={company!} />;
      case 4:
        return <GeneralInfoModalCreateBillingEntity closeModal={() => setEditing(0)} />;
      default:
        return null;
    }
  };

  if (!company)
    return (
      <div className="flex w-full flex-1 flex-col gap-6 lg:px-8">
        <div className="flex flex-row justify-between gap-2 border-0 border-b border-gray-200 pb-5">
          <div className="items-left flex flex-col gap-2">
            <h2 className="text-lg font-semibold">{t("profileGeneralInfoCompany.title")}</h2>
            <p className="text-sm text-gray-600">{t("profileGeneralInfoCompany.subtitle")}</p>
          </div>
          <button
            onClick={() => handleEdit(1)}
            disabled
            className="h-fit rounded-lg border border-gray-200 bg-white px-3 py-2 text-sm font-semibold text-gray-700 hover:bg-gray-200 hover:text-gray-800"
          >
            {t("profileGeneralInfoCompany.edit")}
          </button>
        </div>
        <div>{t("common:states.loading")}</div>
      </div>
    );

  return (
    <div className="flex w-full flex-1 flex-col items-center gap-6 lg:px-8">
      <div className="flex w-full flex-row justify-between gap-2 border-0 border-b border-gray-200 pb-5">
        <div className="items-left flex flex-col gap-2">
          <h2 className="text-lg font-semibold">{t("profileGeneralInfoCompany.title")}</h2>
          <p className="text-sm text-gray-600">{t("profileGeneralInfoCompany.subtitle")}</p>
        </div>
        <div className="flex flex-col gap-4 md:flex-row">
          <button
            onClick={() => handleEdit(4)}
            className="bg-brand700 hover:bg-brand600 h-fit rounded-lg border px-3 py-2 text-sm font-semibold text-white"
          >
            {t("profileGeneralInfoCompany.create")}
          </button>
          <button
            onClick={() => handleEdit(1)}
            className="h-fit rounded-lg border border-gray-200 bg-white px-3 py-2 text-sm font-semibold text-gray-700 hover:bg-gray-200 hover:text-gray-800"
          >
            {t("profileGeneralInfoCompany.edit")}
          </button>
        </div>
      </div>
      <div className="flex w-[95%] flex-col gap-10">
        {defaultBillingEntity && (
          <div className="flex flex-col">
            <h3 className="text-base font-medium text-black">
              {t("profileGeneralInfoCompany.defaultBillingEntityTitle")}
            </h3>
            <BillingEntityGroup {...defaultBillingEntity} />
          </div>
        )}
        {otherBillingEntities?.map((billingEntity) => (
          <div className="flex flex-col" key={billingEntity.id}>
            <h3 className="text-base font-medium text-black">
              {t("profileGeneralInfoCompany.additionalBillingEntityTitle")}
            </h3>
            <BillingEntityGroup {...billingEntity} />
          </div>
        ))}
      </div>
      {displayModal()}
    </div>
  );
};
